<template>
  <div class="result">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="样品信息" name="1">
        <Sample :data="detail.htCheckmallOrderSamplesEx" />
      </el-collapse-item>
      <el-collapse-item title="检测结果" name="2">
        <div class="lists">
          <div
            v-for="(item, index) in reports"
            :key="index"
            class="lists-item pointer"
            @click="fileClick(item)"
          >
            {{ item.checkmallOrderReportName }}
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { deedDetail } from "@/api/userCenter";
import Sample from "./Sample";
export default {
  components: {
    Sample,
  },
  props: {
    deedId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      activeNames: ["1", "2"],
      detail: {},
      reports: [],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.detailLoading = true;
      const data = await this.$axios
        .get(deedDetail, {
          orderId: this.deedId,
        })
        .finally(() => {
          this.detailLoading = false;
        });
      this.detail = data;
      this.reports = data.checkmallOrderReportResponds;
    },
    fileClick(data) {
      window.open(data.checkmallOrderReportPath);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.result {
  padding: 0 15px;
}
.lists {
  min-height: 50px;
  padding-left: 20px;
  &-item {
    margin-bottom: 10px;
    &:hover {
      color: $theme-color;
      text-decoration: underline;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
